
(function(){
  /* --------- small helpers --------- */
  const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

  function parseMoneyToNumber(text){
    if(!text) return NaN;
    // keep digits , . - ; convert comma to dot
    const cleaned = text.replace(/[^\d.,-]/g,'').replace(/,/g,'.');
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : NaN;
  }

  function rowHasFreeBadge(row){
    // any option block that says free/gratis (attr or text)
    const opts = qsa(row, '.upcart-item-option');
    return opts.some(el=>{
      const v = (el.getAttribute('data-upcart-item-option-value')||el.textContent||'').toLowerCase();
      return v.includes('free') || v.includes('gratis');
    });
  }

  function rowIsZeroPrice(row){
    const priceEl = row.querySelector('.upcart-item-price');
    if(!priceEl) return false;
    const n = parseMoneyToNumber(priceEl.textContent);
    return n === 0;
  }

  function markHideStepper(row, hide){
    row.classList.toggle('muzamil-hide-stepper', !!hide);
  }

  function applyHideLogic(drawer){
    const rows = qsa(drawer, '.upcart-products-section .upcart-product-item, .upcart-products-section .styles_ProductRow__product__');
    rows.forEach(row=>{
      const shouldHide = rowHasFreeBadge(row) || rowIsZeroPrice(row);
      markHideStepper(row, shouldHide);
      // Hard-disable inputs as well, in case CSS is overridden
      if(shouldHide){
        const stepper = row.querySelector('.styles_ProductRow__stepper__');
        if(stepper){
          qsa(stepper,'button,input').forEach(el=>{
            el.setAttribute('disabled','disabled');
            el.setAttribute('aria-disabled','true');
          });
        }
      }
    });
  }

  function domShowsSubscription(drawer){
    // Detect “Purchase options: Subscription option” or links that include selling_plan=
    const opts = qsa(drawer, '.upcart-item-option');
    for(const el of opts){
      const cat = (el.getAttribute('data-upcart-item-option-category')||el.textContent||'').toLowerCase();
      const val = (el.getAttribute('data-upcart-item-option-value')||el.textContent||'').toLowerCase();
      if((cat.includes('purchase') || cat.includes('subscription')) &&
         (val.includes('subscription') || val.includes('plan'))){
        return true;
      }
    }
    if (drawer.querySelector('a[href*="selling_plan="]')) return true;
    return false;
  }

  async function fetchCart(){
    try{
      const r = await fetch('/cart.js',{credentials:'same-origin'});
      if(!r.ok) throw new Error('cart.js failed');
      return await r.json();
    }catch(e){
      console.warn('[muzamil] cart.js fetch error', e);
      return null;
    }
  }

  function itemIsSubscription(item){
    if(item.selling_plan_allocation || item.selling_plan) return true;
    const blob = (item.title + ' ' + (item.variant_title||'') + ' ' + JSON.stringify(item.properties||'')).toLowerCase();
    return blob.includes('subscription') || blob.includes('selling_plan') || blob.includes('abon');
  }

  function itemIsFree(item){
    if(item.price === 0 || item.final_price === 0 || item.final_line_price === 0) return true;
    const blob = ((item.variant_title||'') + ' ' + JSON.stringify(item.properties||'')).toLowerCase();
    return blob.includes('free') || blob.includes('gratis');
  }

  async function removeFreebiesIfNoSubscription(drawer){
    // If the visible DOM already shows a subscription, keep freebies
    if (domShowsSubscription(drawer)) return;

    const cart = await fetchCart();
    if(!cart || !Array.isArray(cart.items)) return;
    if(cart.items.some(itemIsSubscription)) return; // keep freebies if a subscription exists

    const updates = {};
    cart.items.forEach(it=>{
      if(itemIsFree(it)){
        // prefer key (Online Store 2.0), fall back to id
        if(it.key){ updates[it.key] = 0; }
        else if(it.id){ updates[it.id] = 0; }
      }
    });
    if(!Object.keys(updates).length) return;

    try{
      await fetch('/cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body: JSON.stringify({ updates })
      });
      // Ask UpCart / theme to refresh
      window.dispatchEvent(new CustomEvent('cart:refresh',{detail:{openDrawer:true}}));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated'));
      window.postMessage({type:'cart:updated'},'*');
    }catch(e){
      console.warn('[muzamil] failed to remove freebies without subscription', e);
    }
  }

  function runAll(drawer){
    applyHideLogic(drawer);
    removeFreebiesIfNoSubscription(drawer);
  }

  function initOnDrawer(drawer){
    if(!drawer || drawer.__muzamilInit) return;
    drawer.__muzamilInit = true;

    // Initial passes (handles internal async renders)
    runAll(drawer);
    setTimeout(()=>runAll(drawer),150);
    setTimeout(()=>runAll(drawer),450);
    setTimeout(()=>runAll(drawer),1000);

    // Watch the drawer for any DOM changes and re-apply rules
    const mo = new MutationObserver(()=> runAll(drawer));
    mo.observe(drawer, { childList:true, subtree:true });

    // Re-apply on common cart events
    ['cart:updated','cart:refresh','cart:change','change','input','upcart:cart:rendered']
      .forEach(evt => document.addEventListener(evt, ()=> setTimeout(()=>runAll(drawer),100)));

    // Safety: re-run around open/close transition
    drawer.addEventListener('transitionend', ()=> {
      setTimeout(()=>runAll(drawer),50);
      setTimeout(()=>runAll(drawer),300);
    });
  }

  function waitForEl(selector, {timeout=30000, poll=120} = {}){
    return new Promise((resolve, reject)=>{
      const now = document.querySelector(selector);
      if(now) return resolve(now);

      let done=false;
      const to = setTimeout(()=>{ if(!done){done=true; mo.disconnect(); reject(new Error('timeout '+selector)); }}, timeout);
      const mo = new MutationObserver(()=> {
        const el = document.querySelector(selector);
        if(el && !done){ done=true; clearTimeout(to); mo.disconnect(); resolve(el); }
      });
      mo.observe(document.documentElement, {childList:true, subtree:true});

      const it = setInterval(()=>{
        if(done) return clearInterval(it);
        const el = document.querySelector(selector);
        if(el){ done=true; clearTimeout(to); mo.disconnect(); clearInterval(it); resolve(el); }
      }, poll);
    });
  }

  // Boot: UpCart uses #CartPopup; we wait for it because the app injects late
  document.addEventListener('DOMContentLoaded', function(){
    waitForEl('#CartPopup')
      .then(initOnDrawer)
      .catch(()=> {
        // fallback: observe body until it appears
        const mo = new MutationObserver(()=>{
          const d = document.querySelector('#CartPopup');
          if(d){ mo.disconnect(); initOnDrawer(d); }
        });
        mo.observe(document.body, {childList:true, subtree:true});
      });
  });
})();
